module.exports = __webpack_public_path__ + "61fe6512ec6fbeac5ccb657be6c77fd0.png";